import React, { useState } from 'react';
import '../css/navBar.css';
import Encabezado from './Encabezado';
import TablaActividades from './TablaActividades';

function MainActividades(){
    const [search, setSearch]=useState(""); 

    return(  
        <>  
            <div id="containerActividades" className='container container-width-85'>
                <Encabezado seccionId={3} setSearch={setSearch}/>      
                <TablaActividades/>
            </div>
        </>
    );
}


export default MainActividades;